module.exports = __webpack_public_path__ + "925a4e2fae47f288549ef71a0ed3f52a.pdf";